// extracted by mini-css-extract-plugin
module.exports = {"dot":"dot-module--dot--1dRii","srOnly":"dot-module--sr-only--cbfId"};